/**
 * The names of the Workflows. This list must be the same values as the adv2-gateway server.
 */
export enum Workflow {
  SimpleDocx = 'SIMPLE_DOCX_S3_SAVE', // TemplateDocumentToS3
  DocumentMerge = 'DOC_MERGE_TEMPLATE',

  // on the server but not used in the manager ui yet
  // EditDocument          = 'EDIT_DOCUMENT',
  // EditDocumentS3        = 'EDIT_DOCUMENT_S3',
  // SendForSignature      = 'SEND_TO_SIGNATURE',
  // ProcessSignature      = 'PROCESS_SIGNATURE',
  // SaveToEntity          = 'SAVE_TO_ENTITY'
}
